import React, {Component} from 'react';
import {history} from '../helper/history';
import localdata from '../helper/localdata';
import swal from 'sweetalert';
import {NavLink} from 'react-router-dom';
import request from 'superagent';
import apis from '../helper/api';
import moment from 'moment';
import action from '../helper/action';
import do_action from '../action';
import {connect} from 'react-redux';
import config from '../helper/config';
import util from '../helper/util';
import Modal from 'react-responsive-modal';
import PospayLogo from '../layout/metronic/logo-color.svg';

class SMSToken extends Component {

    constructor(props) {
        super(props)
        this.state = {
            sms_token: "",
            seconds: '00', 
            minutes: '00',
            disable_resend_btn: true,
            flag_processing: false
        }
        this.secondsRemaining
        this.intervalHandle
        this.handleChange = this.handleChange.bind(this)
        this.startCountDown = this.startCountDown.bind(this)
        this.tick = this.tick.bind(this)
        this.on_submit = this.on_submit.bind(this)
        this.on_resend_token = this.on_resend_token.bind(this)
        this.on_key_press = this.on_key_press.bind(this)
    }

    componentDidMount() {
        let self = this
        this.startCountDown()
    }

    componentWillUnmount() {
        clearInterval(this.intervalHandle)
    }

    handleChange(event) {
        this.setState({minutes: event.target.value})
    }

    tick() {
        var min = Math.floor(this.secondsRemaining / 60)
        var sec = this.secondsRemaining - (min * 60)
        this.setState({
            minutes: min,
            seconds: sec
        })
        if (sec < 10) {
            this.setState({seconds: "0" + this.state.seconds})
        }
        if (min < 10) {
            this.setState({minutes: "0" + min})
        }
        if (min === 0 & sec === 0) {
            this.setState({disable_resend_btn: false})
            clearInterval(this.intervalHandle)
        }
        this.secondsRemaining--
    }

    startCountDown() {
        this.setState({seconds: '00', minutes: '02'})
        this.secondsRemaining = 120
        this.intervalHandle = setInterval(this.tick, 1000)
    }

    on_input_change(e) {
        this.setState({[e.target.name]: e.target.value})
    }

    on_key_press(e) {
        if (e.keyCode == 13) {
            if (e.target.name == "sms_token") {
                this.on_submit()
            }
        }
    }

    on_submit() {
        if (this.state.sms_token.length === 0) return
        let self = this
        let whitelabel_36 = config.whitelabel.toString(36).toUpperCase()
        let body = {
            "white_label_id" : whitelabel_36,
            "username" : this.props.data.username,
            "token_sms" : this.state.sms_token
        }
        this.setState({flag_processing: true})
        request.post(apis.sms_token_submit)
            .set("Content-Type", "application/json")
            .send(body)
            .end(function(err, res) {
                let message_result = ""
                if (err || !res.ok) {
                    util.log(err)
                    message_result = {title: "Error", body: err.message}
                    if (res !== undefined) {
                        message_result.body = "Error code " + res.statusCode
                    }
                } else {
                    util.log(res);
                    if (res.statusCode == 200) {
                        let payload = res.body
                        if (payload.status == "OK") {
                            message_result = {title: "Sukses", body: "Token telah dikirimkan"}
                            if (payload.display_message !== undefined) {
                                message_result = {title: payload.error.message, body: payload.display_message}
                            }
                            self.props.data.on_close()
                        } else {
                            message_result = {title: "Error", body: payload.error.message}
                            if (payload.display_message !== undefined) {
                                message_result = {title: payload.error.message, body: payload.display_message}
                            }
                        }
                    } else {
                        message_result = {title: "Error", body: res.statusCode}
                    }
                    if (message_result.length !== 0) {
                        swal(message_result.title, message_result.body, "warning")
                    }
                }
                self.setState({flag_processing: false})
            })
    }

    on_resend_token() {
        let self = this
        let whitelabel_36 = config.whitelabel.toString(36).toUpperCase()
        let machine_id = util.get_uuid()
        let body = {
            "white_label_id" : whitelabel_36,
            "username" : this.props.data.username,
            "device_id" : machine_id,
            "platform" : "web"
        }
        this.setState({disable_resend_btn: true})
        this.startCountDown()
        request.post(apis.sms_token_resend)
            .set("Content-Type", "application/json")
            .send(body)
            .end(function(err, res) {
                let message_result = ""
                if (err || !res.ok) {
                    util.log(err)
                    message_result = {title: "Error", body: err.message}
                    if (res !== undefined) {
                        message_result.body = "Error code " + res.statusCode
                    }
                } else {
                    util.log(res);
                    if (res.statusCode == 200) {
                        let payload = res.body
                        if (payload.status == "OK") {
                            message_result = {title: "Sukses", body: "Token telah dikirimkan"}
                            if (payload.display_message !== undefined) {
                                message_result = {title: payload.error.message, body: payload.display_message}
                            }
                        } else {
                            message_result = {title: "Error", body: payload.error.message}
                            if (payload.display_message !== undefined) {
                                message_result = {title: payload.error.message, body: payload.display_message}
                            }
                        }
                    } else {
                        message_result = {title: "Error", body: res.statusCode}
                    }
                    if (message_result.length !== 0) {
                        swal(message_result.title, message_result.body, "warning")
                    }
                }
            })
    }

    render() {
        let data = this.props.data
        return (
            <Modal className="modal" open={true} center onClose={data.on_close} showCloseIcon={true} closeOnOverlayClick={false}>
                <div className="modal-dialog modal-lg" role="document" style={{marginTop: 0+'px',marginBottom: 0+'px',width:'500px'}}>
                    <div className="modal-content" style={{border:"white"}}>
                        <div className="modal-header">
                            <h5 className="modal-title">
                                Masukkan SMS Token
                            </h5>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-lg-12">
                                    <span style={{marginBottom: '15px',display: 'block'}}>{data.message}</span>
                                    <div className="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed">
                                        <div className="m-portlet__body">
                                            <input onChange={(e) => this.on_input_change(e)}
                                                onKeyDown={this.on_key_press}
                                                type="text"
                                                className="form-control m-input"
                                                name="sms_token"
                                                value={this.state.sms_token}
                                                placeholder=""/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" onClick={this.on_submit} className={this.state.flag_processing ? 'btn btn-secondary btn-sm m-btn m-btn--custom m-loader m-loader--primary m-loader--right' : 'btn btn-secondary btn-sm m-btn m-btn--custom'} data-dismiss="modal">
                                Submit
                            </button>
                            <button disabled={this.state.disable_resend_btn} type="button" onClick={this.on_resend_token} className="btn btn-secondary" data-dismiss="modal">
                                Kirim Lagi Token ({this.state.minutes} : {this.state.seconds})
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>)
    }
}

class Login extends Component {
    constructor(props) {
        super(props)
        this.state = {
            login_btn: true,
            username: "",
            password: "",
            captha: "",
            captha_img: apis.get_captha,
            type_input_password: 'password',
            show_sms_token: false, 
            message_sms_token: "SMS Token telah dikirimkan ke nomer Anda",
            login_as: 'operator'
        }
        this.login = this.login.bind(this)
        this.on_key_press = this.on_key_press.bind(this)
    }

    onChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    login() {
        if (this.state.username === "" || this.state.password === "" || this.state.captha === "") {
            return swal("Ups !", "Data yang kamu berikan belum valid", "warning")
        }

        let u = this.state.username
        if (this.state.login_as !== 'operator') {
            if (this.state.operator.length === 0) {
                swal("Ups !", "Kode operator tidak valid", 'error')
                return
            }
            u = u + "#" + this.state.operator
        }

        let data = {
            username: u.toUpperCase(),
            password: this.state.password,
            captha: this.state.captha
        }

        let self = this
        let whitelabel_36 = config.whitelabel.toString(36).toUpperCase()
        let machine_id = util.get_uuid()
        let body_1 = {
            "white_label_id": whitelabel_36,
            "captcha": data.captha,
            "device_id" : machine_id
        }
        util.log(body_1)
        self.setState({login_btn: false})
        request.post(apis.login)
            .set("Content-Type", "application/json")
            .send(body_1)
            .end(function(err, res){
                if (err || !res.ok) {
                    util.log(err)
                    if (res !== undefined && res.statusCode == 401) {
                        util.log(res)
                        if (res.headers) {
                            let www_auth = res.headers['www-authenticate']
                            let www_auth_obj = util.parse_www_auth(www_auth)
                            util.log(www_auth_obj)
                            let realm = www_auth_obj.realm
                            let nonce = www_auth_obj.nonce
                            let opaque = www_auth_obj.opaque
                            let uri = "/api/v1/master-agent/auth/login"
                            let postfix_username = data.username.substr(data.username.length - 3)
                            if (self.state.login_as !== 'operator') {
                                if (postfix_username.includes("#")) {
                                    let user_split = postfix_username.split("#");
                                    postfix_username = user_split[1];
                                }
                            }
                            util.log("postfix_username", postfix_username);
                            let pass = whitelabel_36.substring(whitelabel_36.length - 3) + data.password.toString(36) + postfix_username
                            let password_encode = util.md5(pass)
                            let A1 = util.md5(data.username + ":" + realm + ":" + password_encode);
                            let A2 = util.md5("POST" + ":" + uri);
                            let response = util.md5(A1 + ":" + nonce + ":" + A2);
                            
                            util.log("plain pass: " + pass + "\nencode pass: " + password_encode)
                            util.log("realm: "+ realm +"\nnonce: " +nonce+ "\nopaque: " + opaque + "\nA1: " + A1 + "\nA2: " + A2 + "\nResponse: " + response)

                            let body_2 = {
                                "white_label_id": whitelabel_36,
                                "captcha": data.captha,
                                "platform": "web",
                                "device_id" : machine_id
                            }

                            let digest = "Digest username=\"" + data.username + "\",realm=\"" + realm + "\",nonce=\"" +nonce + "\",uri=\"" + uri + "\",response=\"" + response + "\",opaque=\"" + opaque + "\""
                            util.log(digest)

                            request.post(apis.login)
                                .set("Authorization", digest)
                                .set("Content-Type", "application/json")
                                .send(body_2)
                                .end(function(err, res) {
                                    if (err || !res.ok) {
                                        util.log(err)
                                        swal("Ups!", "Error code " + res.statusCode, "warning")
                                    } else {
                                        util.log(res);
                                        if (res.statusCode == 200) {
                                            let payload = res.body
                                            util.log(payload)
                                            if (payload.status == "OK") {
                                                let type = payload.results.user_type
                                                if (type === 'AGENT') {
                                                    swal("Ups!", "Anda login sebagai agent", "warning")
                                                } else if (type === 'MASTER_AGENT') {
                                                    localdata.set_login_result(payload).then((res) => {
                                                        setTimeout(() => {
                                                            history.replace("/master")
                                                        }, 500);
                                                    }).catch((err) => {
                                                        util.log("error", err)
                                                        if (err instanceof DOMException) {
                                                            util.log(err.name)
                                                            if (err.name === "QuotaExceededError") {
                                                                swal("Error", err.name, "error")
                                                            }
                                                        } else {
                                                            if (err.message) {
                                                                swal("Error", err.message, "error")
                                                            }
                                                        }
                                                    })
                                                }
                                            } else {
                                                if (payload.error.code === 3007) {  // SMS Token
                                                    self.setState({show_sms_token: true, message_sms_token: payload.error.message})
                                                } else {
                                                    swal("Ups!", res.body.error.message, "warning")
                                                }
                                            }
                                        } else {
                                            swal("Ups!", "Error code " + res.statusCode, "warning")
                                        }
                                    }
                                    self.setState({login_btn: true})
                                });
                        } else {
                            self.setState({login_btn: true})
                        }
                    } else {
                        if (res !== undefined) {
                            swal("Ups!", "Error code " + res.statusCode, "warning")
                        }
                        self.setState({login_btn: true})
                    }
                } else {
                    if (res != undefined) {
                        util.log(res);
                        swal("Ups!", res.body.error.message, "warning")
                        if (res.body.error.code == 2001) {
                            self.setState({captha_img:apis.get_captha + "?" + moment()});
                        }
                    } else {
                        swal("Ups!", "Error code " + err.message, "warning")
                    }
                    self.setState({login_btn: true})
                }
            })
    }

    refresh() {
        request.get(apis.refresh_captha).end((err, res) => {
            if (err) {
                util.log("error: " + err);
            } else {
                util.log(res);
                if (res.status == 200) {
                    const data = JSON.parse(res.text)
                    if (data.status == "OK") {
                        this.setState({captha_img:apis.get_captha + "?" + moment()});
                    }
                }
            }
        })
    }

    on_key_press(e){
        if (e.keyCode == 13) {
            this.login()
        }
    }

    on_show_hide_password(e) {
        util.log("on_show_hide_password", e)
        if (this.state.type_input_password === 'password') {
            this.setState({type_input_password: 'text'})
        } else {
            this.setState({type_input_password: 'password'})
        }
    }

    on_btn_login_as_operator(e) {
        if (this.state.login_as === 'operator') {
            this.setState({login_as: 'master agen'})
        } else {
            this.setState({login_as: 'operator'})
        }
    }

    render() {
        let self = this
        return (
            <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor m-login m-login--singin m-login--2 m-login-2--skin-3" id="m_login" style={{ backgroundImage: "url(swipe/assets/app/media/img/bg/Optimized-bg-2-min.jpg)" }}>
                <div className="m-grid__item m-grid__item--fluid m-login__wrapper" style={{padding:'0'}}>
                    <div className="m-login__container">
                        <div className="m-login__logo" style={{margin: '60px auto 0rem auto'}}>
                            <img style={{width:'250px', height:'auto', marginBottom:'50px',display:'block',marginLeft:'auto',marginRight:'auto'}} src="../swipe/img/logo.png" />
                        </div>
                        <div className="m-login__signin">
                            <form className="m-login__form m-form" action="" style={{marginBottom: 0,marginTop: '40px'}}>
                                <div className="form-group m-form__group">
                                    <input value={this.state.username} onChange={(e) => this.onChange(e)} className="form-control m-input" type="text" placeholder="Username" name="username" autoComplete="off" />
                                </div>
                                {this.state.login_as !== 'operator' ? 
                                    <div className="form-group m-form__group">
                                        <input value={this.state.operator} onChange={(e) => this.onChange(e)} className="form-control m-input" type="text" placeholder="Kode Operator" name="operator" autoComplete="off" />
                                    </div>
                                : ''}
                                <div className="form-group m-form__group">
                                    <div className="m-input-icon m-input-icon--right">
                                        <input value={this.state.password} onChange={(e) => this.onChange(e)} className="form-control m-input m-login__form-input--last" type={this.state.type_input_password} placeholder="Password" name="password" />
                                        <span className="m-input-icon__icon m-input-icon__icon--right" style={{width: '4rem'}}>
                                            <span onClick={(e) => this.on_show_hide_password(e)}>
                                                <i className={this.state.type_input_password === 'password' ? 'la la-eye' : 'la la-eye-slash'}></i>
                                            </span>
                                        </span>
                                    </div>
                                </div>
                                
                                <div className="form-group m-form__group row" style={{marginTop: '10px'}}>
                                    <div className="m--align-left m-login__form-left">
                                        <img id="captcha-img" min-width="100px" style={{marginTop:'10px',marginLeft:'10px',borderRadius:'10px'}} src={this.state.captha_img}/>
                                    </div>
                                    <div style={{marginTop: '40px',marginLeft: '10px'}}>
                                        <i className="la la-refresh" onClick={() => this.refresh()}></i>
                                    </div>
                                    <div className="col m--align-right m-login__form-right" style={{paddingRight: '2px'}}>
                                        <input value={this.state.captha} onChange={(e) => this.onChange(e)} onKeyDown={this.on_key_press} className="form-control m-input m-login__form-input--last" type="text" placeholder="Captcha" name="captha" autoComplete="off" />
                                    </div>
                                </div>
                                <div className="row m-login__form-sub">
                                    <div className="col m--align-left m-login__form-left" style={{paddingLeft: 0}}>
                                        <label className="m-checkbox  m-checkbox--light" style={{fontWeight: 500}}>
                                            <input type="checkbox" name="remember" />
                                            Simpan password ini
										<span></span>
                                        </label>
                                    </div>
                                    <div className="col m--align-right m-login__form-right" style={{paddingRight: 0}}>
                                        <a onClick={() => this.on_btn_login_as_operator()} className="m-link" style={{cursor:"pointer",fontWeight:'500'}}>Login sebagai {this.state.login_as}</a>
                                        <NavLink id="m_login_forget_password" className="m-link" 
                                        to="/forgot-password" style={{fontWeight: 500}}>
                                            Lupa Password
                                        </NavLink>
                                    </div>
                                </div>
                                <div className="m-login__form-action">
                                    <button type="button" disabled={this.state.login_btn === false} 
                                    onClick={() => this.login()} id="m_login_signin_submit" 
                                    className={this.state.login_btn ? "btn btn-focus m-btn m-btn--pill m-btn--custom m-btn--air m-login__btn" : "btn btn-focus m-btn m-btn--pill m-btn--custom m-btn--air m-login__btn m-loader m-loader--light m-loader--right"}>
                                        Login
								    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                {this.state.show_sms_token? <SMSToken data={{message: this.state.message_sms_token, username: this.state.username, on_close: ()=>{
                    self.setState({show_sms_token: false})
                }}}/> : ''}
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    user: state.User
})

export default connect(mapStateToProps, null)(Login)


// WEBPACK FOOTER //
// ./src/component/login.js